import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { KeyDefinitionType } from '@wix/unidriver-core';
import {
  buttonNextDriverFactory,
  ButtonNextDriver,
} from '../internal/WixUiCoreComponents/components/CoreButtonNext/CoreButtonNext.uni.driver';
import { tooltipDriverFactory } from '../internal/WixUiCoreComponents/components/CoreTooltip/CoreTooltip.uni.driver';
import { uniDriverImplementation } from '../../test/unidriver-config';
import { getAsyncElementFinder } from '../../test/unidriver-mixins';

export interface IconTooltipDriver
  extends BaseUniDriver,
    ButtonNextDriver,
    Pick<
      ReturnType<typeof tooltipDriverFactory>,
      | 'clickOutside'
      | 'getTooltipText'
      | 'mouseEnter'
      | 'mouseLeave'
      | 'tooltipExists'
    > {
  getTooltipId(): Promise<string>;
  getTooltipContent(): UniDriver;
  getIconButtonDescription(): UniDriver;
  pressKey(key: KeyDefinitionType): Promise<void>;
}

export const iconTooltipDriverFactory = (
  base: UniDriver,
  body: UniDriver,
): IconTooltipDriver => {
  const {
    clickOutside,
    getTooltipText,
    mouseEnter,
    mouseLeave,
    tooltipExists,
  } = tooltipDriverFactory(base, body);
  const buttonUniDriver = base.$('button');
  const buttonDriver = buttonNextDriverFactory(buttonUniDriver);

  const getTooltipId = async () => {
    return buttonUniDriver.attr('aria-labelledby');
  };

  return {
    ...buttonDriver,
    clickOutside,
    getTooltipId,
    getTooltipContent() {
      return uniDriverImplementation.current(async () => {
        const selector = `[role=tooltip] > #${await getTooltipId()}`;
        return getAsyncElementFinder(body.$(selector));
      });
    },
    getIconButtonDescription() {
      return uniDriverImplementation.current(async () => {
        const selector = `button ~ #${await getTooltipId()}`;
        return getAsyncElementFinder(body.$(selector));
      });
    },
    getTooltipText,
    mouseEnter,
    mouseLeave,
    pressKey: buttonUniDriver.pressKey,
    tooltipExists,
  };
};
